import * as React from "react";
import { BaseComponent } from "../../../../react-core/Html/BaseComponent";
import { IStepConfig } from "./Process";

export interface IProcessStepperMobileProps extends React.Props<ProcessStepperMobile> {
    currentStep: number;
    config: IStepConfig[];
}

export interface IProcessStepperMobileState {}

export class ProcessStepperMobile extends BaseComponent<IProcessStepperMobileProps, IProcessStepperMobileState> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <div className="wizard-stepper-mobile">
                Step {this.props.currentStep + 1} of {this.props.config.length} -{" "}
                <b>{this.props.config[this.props.currentStep].title}</b>
            </div>
        );
    }
}
